import {FC, useEffect, useState} from 'react'
import {useFormContext} from 'react-hook-form'
import {
  SelectWrapper,
  InputTextWrapper,
  InputNumberWrapper,
} from '../../../../../../components/UI/Form/Input'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {formatDateType2} from '../../../../../../util/dates'
import {ClientModel, CompanyModel} from '../../../../../central/model'
import {useCentralServices} from '../../../../hooks/useCentralServices'
import {CampModel, MasterModel, SiteModel} from '../../models'
import {getModuleByIdService} from '../../services'
import AditionalCamp from '../../../../../../components/UI/Form/aditionalCamp'
const FormModule: FC = () => {
  const {setError, setValue} = useFormContext()

  const {currentTabItem} = useHoteleria()

  const [sites, setSites] = useState<SiteModel[] | any>([])
  const [camps, setCamps] = useState<CampModel[] | any>([])
  const [moduleType, setModuleType] = useState<MasterModel[] | any>([])
  const [preasignationType, setPreasignationType] = useState<MasterModel[] | any>([])
  const [genre, setGenre] = useState<MasterModel[] | any>([])
  const [bathroomType, setBathroomType] = useState<MasterModel[] | any>([])
  const [statusType, setStatusType] = useState<MasterModel[] | any>([])
  const [typeBuildings, setTypeBuildings] = useState<MasterModel[] | any>([])
  const [company, setCompany] = useState<CompanyModel[] | any>([])
  const [client, setClient] = useState<ClientModel[] | any>([])

  const {getCompanies, getClients, getSites, getCamps, getMasterTable} = useCentralServices()

  const getCompaniesFn = async () => {
    const data = await getCompanies({isCombo: true}, 1)
    if (data.length === 1) {
      setValue('CompaniaId', data[0].value)
      setError('CompaniaId', {})
      await getClientsFn(data[0].value as string)
    }
    setCompany(data)
  }

  const getClientsFn = async (companyId: string) => {
    const data = await getClients({isCombo: true, companiaId: companyId}, 1)
    if (data.length === 1) {
      setValue('ClienteId', data[0].value)
      setError('ClienteId', {})
      await getSitesFn(data[0].value as string)
    }
    setClient(data)
  }

  const getSitesFn = async (clientId: string) => {
    const data = await getSites({isCombo: true, clienteId: clientId}, 1)
    if (data.length === 1) {
      setValue('SiteId', data[0].value)
      setError('SiteId', {})
      await getCampsFn(data[0].value as string)
    }
    setSites(data)
  }

  const getCampsFn = async (siteId: string) => {
    const data = await getCamps({isCombo: true, siteId: siteId}, 1)
    if (data.length === 1) {
      setValue('CampamentoId', data[0].value)
      setError('CampamentoId', {})
    }
    setCamps(data)
  }
  const getModuleTypesFn = async () => {
    const data = await getMasterTable('TipoModulo', true)
    setModuleType(data)
  }

  const getStatusTypesFn = async () => {
    const data = await getMasterTable('EstadoModulo', true)
    setStatusType(data)
  }

  const getPreasignationTypesFn = async () => {
    const data = await getMasterTable('TipoPreasignacion', true)
    setPreasignationType(data)
  }
  const getGenresFn = async () => {
    const data = await getMasterTable('Sexo', true)
    setGenre(data)
  }
  const getBathroomsTypeFn = async () => {
    const data = await getMasterTable('TipoBanio', true)
    setBathroomType(data)
  }

  const getTypeBuildings = async () => {
    const data = await getMasterTable('TipoEdificacion', true)
    setTypeBuildings(data)
  }

  useEffect(() => {
    getModuleTypesFn()
    getPreasignationTypesFn()
    getGenresFn()
    getBathroomsTypeFn()
    getStatusTypesFn()
    getCompaniesFn()
    getTypeBuildings()
  }, [])

  useEffect(() => {
    if (preasignationType.length > 0) {
      const defatultPreasignation = preasignationType.find(
        (item: any) => item.label === 'NO PERMANENTE',
      )?.value
      if (!currentTabItem.idToEdit) {
        setValue('TipoPreAsignacionId', defatultPreasignation)
      }
    }
  }, [preasignationType])

  useEffect(() => {
    if (statusType.length > 0) {
      const defaultStatus = statusType.find((item: any) => item.label === 'DISPONIBLE')?.value
      if (!currentTabItem.idToEdit) {
        setValue('EstadoModuloId', defaultStatus)
      }
    }
  }, [statusType])

  const getModuleById = async () => {
    try {
      const {idToEdit} = currentTabItem
      if (idToEdit) {
        const {
          data: {data},
        } = await getModuleByIdService(idToEdit)
        if (data) {
          const {
            CampamentoId,
            SiteId,
            TipoModuloId,
            Codigo,
            EstadoModuloId,
            TipoPreAsignacionId,
            SexoId,
            TipoBanioId,
            // NivelId,
            NroPisos,
            NroHabitaciones,
            PrioridadAsignacion,
            CompaniaId,
            ClienteId,
            Campoadicionaltxt1,
            Campoadicionaltxt2,
            Campoadicionaltxt3,
            Campoadicionaltxt4,
            Campoadicionaltxt5,
            Campoadicionalnum1,
            Campoadicionalnum2,
            Campoadicionalnum3,
            CampoadicionalFec1,
            CampoadicionalFec2,
            // TipoEdificacionId,
          } = data

          setValue('Id', idToEdit)
          setValue('CampamentoId', CampamentoId)
          setValue('CompaniaId', CompaniaId)
          setValue('ClienteId', ClienteId)
          setValue('SiteId', SiteId)
          setValue('TipoModuloId', TipoModuloId)
          setValue('Codigo', Codigo)
          setValue('EstadoModuloId', EstadoModuloId)
          setValue('TipoPreAsignacionId', TipoPreAsignacionId)
          setValue('SexoId', SexoId)
          setValue('TipoBanioId', TipoBanioId)
          setValue('NroPisos', NroPisos)
          setValue('NroHabitaciones', NroHabitaciones)
          // setValue('TipoEdificacionId', TipoEdificacionId)
          setValue('PrioridadAsignacion', PrioridadAsignacion)
          setValue('Campoadicionaltxt1', Campoadicionaltxt1)
          setValue('Campoadicionaltxt2', Campoadicionaltxt2)
          setValue('Campoadicionaltxt3', Campoadicionaltxt3)
          setValue('Campoadicionaltxt4', Campoadicionaltxt4)
          setValue('Campoadicionaltxt5', Campoadicionaltxt5)
          setValue('Campoadicionalnum1', Campoadicionalnum1)
          setValue('Campoadicionalnum2', Campoadicionalnum2)
          setValue('Campoadicionalnum3', Campoadicionalnum3)
          setValue('CampoadicionalFec1', formatDateType2(CampoadicionalFec1))
          setValue('CampoadicionalFec2', formatDateType2(CampoadicionalFec2))
          getClientsFn(CompaniaId as any)
          getSitesFn(ClienteId as any)
          getCampsFn(SiteId as any)
        }
      }
    } catch (error) {}
  }

  useEffect(() => {
    if (currentTabItem.idToEdit) {
      getModuleById()
    }
  }, [currentTabItem.idToEdit])

  const handleCompanyChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('CompaniaId', value)
    setValue('ClienteId', '')
    setValue('SiteId', '')
    setSites([])
    setValue('CampamentoId', '')
    setCamps([])
    setError('CompaniaId', {})
    getClientsFn(value)
  }

  const handleClientChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('ClienteId', value)
    setValue('SiteId', '')
    setValue('CampamentoId', '')
    setCamps([])
    setError('ClienteId', {})
    getSitesFn(value)
  }

  const handleSiteChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('SiteId', value)
    setValue('CampamentoId', '')
    setError('SiteId', {})
    getCampsFn(value)
  }

  return (
    <div className='sdx_form card p-4'>
      <div className='d-flex row'>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Compañia'
            name='CompaniaId'
            data={company}
            onChangeValue={handleCompanyChange}
            required
          />
        </div>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Cliente'
            name='ClienteId'
            data={client}
            onChangeValue={handleClientChange}
            required
          />
        </div>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Site'
            name='SiteId'
            data={sites}
            onChangeValue={handleSiteChange}
            required
          />
        </div>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper labelText='Campamento' name='CampamentoId' data={camps} required />
        </div>
      </div>
      <div className='d-flex row'>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <InputTextWrapper
            labelText='Nomenclatura de Módulo'
            name='Codigo'
            textPlaceholder='Escribe el Codigo'
            type='ticketNumber'
            required
          />
        </div>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Tipo de Módulo'
            name='TipoModuloId'
            data={moduleType}
            required
          />
        </div>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper labelText='Estado' name='EstadoModuloId' data={statusType} required />
        </div>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper labelText='Sexo' name='SexoId' data={genre} required />
        </div>
      </div>
      <div className='d-flex row'>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper labelText='Tipo de Baño' name='TipoBanioId' data={bathroomType} required />
        </div>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <InputNumberWrapper
            labelText='Pisos'
            name='NroPisos'
            textPlaceholder='Escribe el Numero de Pisos'
            required
          />
        </div>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <InputNumberWrapper
            labelText='Nro de Habitaciones'
            name='NroHabitaciones'
            textPlaceholder='Escribe el Numero de Habitaciones'
            required
          />
        </div>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <InputNumberWrapper
            labelText='Nro de Secuencia de Asignación'
            name='PrioridadAsignacion'
            textPlaceholder='Escribe el Numero de Habitaciones'
            required
          />
        </div>
        {/* <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Tipo de Edificación'
            name='TipoEdificacionId'
            data={typeBuildings}
            required
          />
        </div> */}
      </div>
      <hr className='divider' />
      <AditionalCamp module='hoteleria' />
    </div>
  )
}

export {FormModule}
